import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { HeaderContext } from '@contexts/HeaderContext';

const CopySiteWarningModal = () => {
    const [state, dispatch] = useContext(HeaderContext);
    const { isShowCopySiteWarningPopup } = state;
    const { t } = useTranslation();
    const [doNotShowAgain, setDoNotShowAgain] = useState(false);

    useEffect(() => {
        const doNotShowAgain = localStorage.getItem('doNotShowCopySiteWarning');
        if (doNotShowAgain) {
            dispatch({ type: 'HIDE_COPYSITE_WARNING_POPUP' });
        } else {
            dispatch({ type: 'SHOW_COPYSITE_WARNING_POPUP' });
        }
    }, [dispatch]);

    const closeConfirmURLPopup = () => {
        if (doNotShowAgain) {
            localStorage.setItem('doNotShowCopySiteWarning', true);
        }
        dispatch({ type: 'HIDE_COPYSITE_WARNING_POPUP' });
    };

    const handleDoNotShowAgainChange = (event) => {
        const isChecked = event.target.checked;
        setDoNotShowAgain(isChecked);
    };

    return (
        <div className="modal modal--alert" data-open={isShowCopySiteWarningPopup} onClick={closeConfirmURLPopup}>
            <div className="modal__dialog" onClick={(e) => e.stopPropagation()}>
                <div className="modal__close" onClick={closeConfirmURLPopup}>
                    <a className="btn btn--icon">
                        <i className="icon icon--close" />
                    </a>
                </div>
                <div className="modal__header">
                    <span className="text">{t('lbl_CopySiteWarning1')}</span>
                </div>
                <div className="modal__body">
                    <p>
                        <span className="text">{t('lbl_CopySiteWarning2')}</span>
                    </p>
                    <a className="btn btn--secondary" onClick={closeConfirmURLPopup}>
                        <span className="text">{t('lbl_ok')}</span>
                    </a>
                    <label className="checkbox">
                        <input type="checkbox" onChange={handleDoNotShowAgainChange} />
                        <i className="icon icon--checkbox" />
                        <span className="text">{t('DoNotShowAgain')}</span>
                    </label>
                </div>
            </div>
        </div>
    );
};

export default CopySiteWarningModal;
